import {
  Body,
  Box,
  Dialog,
  RadioGroup,
  Space,
  useIsMobileLayout,
  WarningIcon,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";
import { constant, constFalse, pipe } from "fp-ts/function";
import { boolean, option } from "fp-ts";
import { useState } from "react";

type Props = {
  onAnswer: (answer: boolean) => unknown;
  onDismiss: () => unknown;
};

export function MarketingConsentConfirmationDialog(props: Props) {
  const formatMessage = useFormatMessage();
  const isMobileLayout = useIsMobileLayout();
  const [answer, setAnswer] = useState<boolean>();
  return (
    <Dialog
      ariaLabelMessageForCloseIcon={formatMessage("Modal.closeButton")}
      variant="left"
      size="medium"
      title={formatMessage("UKonto.ReadDocuments.MarketingConsentModal.title")}
      onDismiss={option.some(props.onDismiss)}
      actions={[
        {
          label: formatMessage(
            "UKonto.ReadDocuments.MarketingConsentModal.confirm"
          ),
          action: () => props.onAnswer(answer!),
          variant: "primary",
          disabled: answer === undefined || answer === null,
        },
      ]}
      icon={WarningIcon}
    >
      <Box column shrink style={{ marginLeft: "6px", marginRight: "6px" }}>
        <Body size={"medium"} weight={"regular"}>
          {formatMessage(
            "UKonto.ReadDocuments.MarketingConsentModal.description"
          )}
        </Body>
        <Space units={4} />
        <RadioGroup
          name="overdraftSelected"
          variant={isMobileLayout ? "vertical" : "horizontal"}
          options={[true, false]}
          value={option.fromNullable(answer)}
          disabled={false}
          onChange={selected =>
            pipe(
              selected,
              option.fold(
                () => setAnswer(undefined),
                v => setAnswer(v)
              )
            )
          }
          isOptionDisabled={constFalse}
          issuesType={option.none}
          optionKey={value => value.toString()}
          renderOptionChildren={constant(option.none)}
          renderOption={boolean.fold(
            () =>
              formatMessage(
                "UKonto.ReadDocuments.MarketingConsentModal.cancelLabel"
              ),
            () =>
              formatMessage(
                "UKonto.ReadDocuments.MarketingConsentModal.confirmLabel"
              )
          )}
        />
        <Space units={4} />
      </Box>
    </Dialog>
  );
}
